module.exports = __webpack_public_path__ + "img/1440.cd9bdb53.jpg";